module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "abb"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0005#rabb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AB")]), _vm._v(" Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ABD")])]), _vm._v(" "), _c('em', [_vm._v("Anchor Bible Dictionary")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Adv. Haer.")])]), _vm._v(" "), _c('em', [_vm._v("Adversus Haereses")]), _vm._v(" (Irenaeus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AnBib")]), _vm._v(" Analectia Biblica")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Ant.")])]), _vm._v(" "), _c('em', [_vm._v("Antiquities")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ASNU")]), _vm._v(" Acta Seminarii Neotestamentici Upsaliensis")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("b.")]), _vm._v(" Babylonian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("BeO")])]), _vm._v(" "), _c('em', [_vm._v("Bibbia e oriente")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BETL")]), _vm._v(" Bibliotheca ephemeridum theologicarum lovaniensium")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Bib")])]), _vm._v(" "), _c('em', [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BIS")]), _vm._v(" Biblical Interpretation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("BJRL")])]), _vm._v(" "), _c('em', [_vm._v("Bulletin of the John Rylands Library")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BNTC")]), _vm._v(" Black’s (Harper’s) New Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("BZ")])]), _vm._v(" "), _c('em', [_vm._v("Biblische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZNW")]), _vm._v(" Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("C. Ap.")])]), _vm._v(" "), _c('em', [_vm._v("Contra Apionem")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("C. Cels.")])]), _vm._v(" "), _c('em', [_vm._v("Contra Celsum")]), _vm._v(" (Origen)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CB[NT]")]), _vm._v(" Coniectanea biblica: New Testament Series, Coniectanea neotestamentica")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("CBQ")])]), _vm._v(" "), _c('em', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CCSA")]), _vm._v(" Corpus Christianorum Series Apocryphorum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CG")]), _vm._v(" Corpus Gnosticum (Nag Hammadi Library)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CGTC")]), _vm._v(" Cambridge Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CSCO")]), _vm._v(" Corpus Scriptorum Christianorum Orientalium")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("De vir. ill.")])]), _vm._v(" "), _c('em', [_vm._v("De viris illustribus")]), _vm._v(" (Jerome)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("DJD")]), _vm._v(" Discoveries in the Judean Desert")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Ep.")])]), _vm._v(" "), _c('em', [_vm._v("Epistulae")]), _vm._v(" (Pliny, Seneca)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ETL")])]), _vm._v(" "), _c('em', [_vm._v("Ephemerides theologicae lovanienses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ExpT")])]), _vm._v(" "), _c('em', [_vm._v("Expository Times")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FRLANT")]), _vm._v(" Forschungen zur Religion und Literatur des Alten und Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HDR")]), _vm._v(" Harvard Dissertations in Religion")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Hist. Conscr.")])]), _vm._v(" "), _c('em', [_vm._v("Quomodo historia conscribenda sit")]), _vm._v(" (Lucian of Samosata)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Hist. Eccl.")])]), _vm._v(" "), _c('em', [_vm._v("Historia ecclesiastica")]), _vm._v(" (Eusebius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HTKNT")]), _vm._v(" Herders theologischer Kommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("HTR")])]), _vm._v(" "), _c('em', [_vm._v("Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ICC")]), _vm._v(" International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("IEJ")])]), _vm._v(" "), _c('em', [_vm._v("Israel Exploration Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Inst.")])]), _vm._v(" "), _c('em', [_vm._v("Institutio oratoria")]), _vm._v(" (Quintilian)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("Int")])]), _vm._v(" "), _c('em', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JBL")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JECS")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Early Christian Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JEH")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Ecclesiastical History")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JHS")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Hellenic Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JJS")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Jewish Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JR")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JSHJ")])]), _vm._v(" "), _c('em', [_vm._v("Journal for the Study of the Historical Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JSJ")])]), _vm._v(" "), _c('em', [_vm._v("Journal for the Study of Judaism in the Persian, Hellenistic, and Roman Periods")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JSNT")])]), _vm._v(" "), _c('em', [_vm._v("Journal for the Study of the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSNTSup")]), _vm._v(" Journal for the Study of the New Testament Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSOTSup")]), _vm._v(" Journal for the Study of the Old Testament Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JSS")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Semitic Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("JTS")])]), _vm._v(" "), _c('em', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("m.")]), _vm._v(" Mishnah")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICNT")]), _vm._v(" New International Commentary on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIGTC")]), _vm._v(" New International Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("NovT")])]), _vm._v(" "), _c('em', [_vm._v("Novum Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NovTSup")]), _vm._v(" Novum Testamentum Supplements")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NRSV")]), _vm._v(" New Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("NTS")])]), _vm._v(" "), _c('em', [_vm._v("New Testament Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Pap. Oxy.")]), _vm._v(" Oxyrhynchus Papyri/us")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("PEQ")])]), _vm._v(" "), _c('em', [_vm._v("Palestine Exploration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("RB")])]), _vm._v(" "), _c('em', [_vm._v("Revue biblique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLDS")]), _vm._v(" Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SC")]), _vm._v(" Sources chrétiennes")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SNTSMS")]), _vm._v(" Society for New Testament Studies Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("SPAW")])]), _vm._v(" Sitzungsberichte der Preußischen Akademie der Wissenschaften")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ST")])]), _vm._v(" "), _c('em', [_vm._v("Studia Theologica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("STAR")]), _vm._v(" Studies in Theology and Religion")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TSAJ")]), _vm._v(" Texte und Studien zum antiken Judentum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TU")]), _vm._v(" Texte und Untersuchungen")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("TynB")])]), _vm._v(" "), _c('em', [_vm._v("Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WBC")]), _vm._v(" Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("WTJ")])]), _vm._v(" "), _c('em', [_vm._v("Westminster Theological Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WUNT")]), _vm._v(" Wissenschaftliche Untersuchungen zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("y.")]), _vm._v(" Jerusalem Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ZAC")])]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift für Antikes Christentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_c('em', [_vm._v("ZNW")])]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f7b962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-bauckham-0008.vue
// module id = 75
// module chunks = 0